// extracted by mini-css-extract-plugin
export var feedbackBtn = "feedback-fab-module--feedbackBtn--c87c6";
export var feedbackIcon = "feedback-fab-module--feedbackIcon--e5e63";